<template>
  <el-dialog
    custom-class="admin-dialog-modal" :title="`${instrument._id ? 'EDIT' : 'NEW'} SOURCE`"
    :model-value="flagVisible" width="770px" :before-close="handleClose"
  >
    <div class="source-steps">
      <div class="step-item">
        <span>Step 1: Enter information about this Source and click SAVE.</span>
      </div>
      <div class="step-item">
        <span>Step 2: Choose the Source you just created from the list and click "Upload".</span>
      </div>
      <div class="step-info">
        <span>IMPORTANT: Make sure to upload your audio in its highest original resolution, for example, 16bit 44.1k, 32bit 96k, etc.</span>
      </div>
    </div>
    <div class="source-title">
      <span>SOURCE INFO</span>
    </div>
    <el-form ref="form" :model="instrument" label-position="top" size="small">
      <el-form-item>
        <el-input v-model="instrument.name" placeholder="Source Name [eg. Vocal, Singing, Male. Vocal, Rap, Female. Electric Guitar. Etc.]"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.instrument_brand" placeholder="Instrument brand [eg. Gibson]"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.instrument_details" placeholder="Instrument details, if additional [eg. 1953 Les Paul]"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.performer_name" placeholder="Performer(s), separated by commas [eg. Diana Ross]"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.producer_engineer" placeholder="Producer(s), Engineer(s), separated by commas"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.room_studio" placeholder="Room or Studio [eg. EastWest Studio 2. Large live room. Small bedroom. Etc.]"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.mic_distance_source" placeholder="Microphone distance from source"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.mic_axis" placeholder="Microphone axis"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.mic_cable_brand" placeholder="Mic cable brand"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.preamp_brand" placeholder="Preamp brand"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.additional_pre_processing" placeholder="Additional pre-processing"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.a_d_converter" placeholder="A/D Converter"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="instrument.additional_post_processing" placeholder="Additional post-processing"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="small" class="el-btn-blue" :loading="flagLoading.save" @click="handleSave">SAVE</el-button>
        <el-button size="small" @click="handleClose">CANCEL</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive } from 'vue'
export default {
  props: {
    role: String,
    flagVisible: Boolean,
    actionItem: Object
  },
  emits: ['closeModal', 'reloadInstruments'],
  data: function () {
    const flagLoading = reactive({
      save: false
    })
    return {
      instrument: {},
      flagLoading
    }
  },
  created: function () {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) this.instrument = { ...val }
      },
      deep: true
    }
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    },
    handleSave: function () {
      if (!this.instrument._id) {
        this.createInstrument()
      } else {
        this.updateInstrument()
      }
    },
    createInstrument: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/instruments`
      const that = this
      const body = { ...this.instrument }
      this.$service.post(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Create instrument success' })
          that.handleClose()
          setTimeout(function () {
            that.$emit('reloadInstruments', that.instrument.song_id)
          }, 100)
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('createInstrument', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    updateInstrument: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/instruments/${this.instrument._id}`
      const that = this
      const body = { ...this.instrument }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update instrument success' })
          that.handleClose()
          setTimeout(function () {
            that.$emit('reloadInstruments', that.instrument.song_id)
          }, 100)
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateInstrument', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.source-steps {
  color: black;
  margin-bottom: 60px;
  .step-item {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .step-info {
    font-size: 16px;
  }
}
.source-title {
  color: black;
  font-size: 18px;
  margin-bottom: 30px;
}
</style>
